import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "submit"]
  static values = { name: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const count = this.selectedCount

    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasSubmitTarget) this.submitTarget.disabled = count === 0
  }

  get selectedCount() {
    const selector = `[name="${this.nameValue}"]`
    const checked = this.element.querySelectorAll(`input[type="checkbox"]${selector}:checked`)
    const carried = this.element.querySelectorAll(`input[type="hidden"]${selector}`)

    return checked.length + carried.length
  }
}
